import { render, staticRenderFns } from "./PartCatalogue.vue?vue&type=template&id=4397bbae&"
import script from "./PartCatalogue.vue?vue&type=script&lang=js&"
export * from "./PartCatalogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports